import React, { useEffect, useState, useRef } from "react";

import {
  SearchOutlined,
  EditOutlined,
  ReloadOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  PageHeader,
  Pagination,
  Input,
  Button,
  Table,
  Spin,
  Typography,
  Tag,
} from "antd";

import moment from "moment";

import GenericTable from "../../components/Generic/Table";
import AddEditModal from "../../components/Generic/AddEditModal";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getData, loadMoreData } from "../../Redux/actions/crudActions";
import "./styles.scss";
import "./styles.css";

const { Search } = Input;
const INITIAL_STATE = {
  searchText: "",
};
const API_URL = "brands";

const PAGENAME = "Brands";

const MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },
  // {
  //   title: 'Admin only',
  //   key: 'admin_only',
  //   type: 'boolean'
  // },
];

const Index = (props) => {
  const [loading, setloading] = useState(true);
  const [mainSearch, setMainSearch] = useState(null);
  const [resetTable, setResetTable] = useState(false);

  const [modalMode, setModalMode] = useState("edit");
  const [currentSelected, setCurrentSelected] = useState(null);

  const tableRef = useRef();
  const dispatch = useDispatch();
  const { crudData, crudDataCount } = useSelector(
    (state) => ({
      crudData: state.crudReducer.data,
      crudDataCount: state.crudReducer.dataCount,
    }),
    shallowEqual
  );
  useEffect(() => {}, []);

  const onSearch = (value) => {
    setMainSearch(value);
  };

  const itemSelected = (value) => {
    setModalMode("edit");
    setCurrentSelected(value);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      search: "name",
    },
    // {
    //   title: 'Admin only',
    //   dataIndex: 'admin_only',
    //   key: 'admin_only',

    //   sorter: (a, b) => a.admin_only > b.admin_only,
    //     render: row =>{
    //       var editItem = row
    //       if(editItem === true){
    //           return <CheckOutlined />;
    //       }else{
    //           return <CloseOutlined />;
    //       }
    //     }
    // }
  ];

  return (
    <div className="maindiv">
      <div className={"generic_container"}>
        <PageHeader
          title={"Brands"}
          subTitle={
            <div className={"header"}>
              {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
            </div>
          }
          extra={
            <div className={"header"}>
              {/* <UserModal headername={PAGENAME} currentItem={currentSelected} 
                        modalMode={modalMode} blueprint={MODAL_BLUEPRINT} apiurl={API_URL} 
                        token={props.session.access}
                        onModalClose={(action)=>{
                          setCurrentSelected(null);
                          if(action =='reset'){setResetTable(!resetTable)}
                        }}                     
                      /> */}
              <AddEditModal
                headername={PAGENAME}
                currentItem={currentSelected}
                modalMode={modalMode}
                blueprint={MODAL_BLUEPRINT}
                apiurl={API_URL}
                onModalClose={(action) => {
                  setModalMode("add");
                  setCurrentSelected(null);
                  if (action == "reset") {
                    setResetTable(!resetTable);
                  }
                }}
              />

              {crudDataCount > 0 ? (
                <Button
                  type={"primary"}
                  shape={"round"}
                  onClick={() => {
                    dispatch(loadMoreData());
                  }}
                  style={{ marginRight: "1em" }}
                >
                  Load More
                </Button>
              ) : null}

              <Button
                onClick={() => {
                  setResetTable(!resetTable);
                }}
                className="button"
              >
                <ReloadOutlined />
              </Button>
            </div>
          }
        ></PageHeader>
        <div className={"content_container"}>
          <GenericTable
            ref={tableRef}
            apiurl={API_URL}
            columns={columns}
            mainSearch={mainSearch}
            resetTable={resetTable}
            ChangedSelected={(selected) => {
              itemSelected(selected);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
